import React from 'react'
import { useTranslation } from 'react-i18next'
import { useMe } from '../../../hooks/useMe'
import FactGrid from '../FactGrid'

export default function LocationFacts({ parcel }) {
  const { t } = useTranslation('parcels')
  const { carrier } = useMe()

  const address = parcel.location?.address
  const facts = [
    address && {
      key: 'location',
      wide: true,
      label: t('location'),
      value: `${address.street}, ${address.zip} ${address.city}`,
    },
    parcel.controller?.mark && {
      key: 'locker',
      label: t('locker'),
      value: parcel.controller.mark,
    },
    parcel.boxNumber && {
      key: 'box',
      label: t('box'),
      value: `${parcel.boxNumber}${parcel.isQueued ? ` (${t('queued')})` : ''}`,
    },
    carrier.isIboxen &&
      parcel.controller?.softwareVersion && {
        key: 'controllerSoftware',
        label: t('controllerSoftware'),
        value: parcel.controller.softwareVersion,
      },
  ].filter(Boolean)
  if (facts.length === 0) return null

  return <FactGrid facts={facts} />
}
